import repository from '@/api'
import { AttachedImage } from 'eop-ui-core/types/AttachedImage'
import { MyPortlet } from '@/models/Portlet'

const URI = '/v1/my-dashboard'
export default {
  findMyDashboard() {
    return repository.get<Dashboard>(`${URI}`)
  },
  addPortlet({ portletNo, workplaceId }) {
    return repository.post(`${URI}/add-portlet`, { portletNo, workplaceId })
  },
  removeMyPortlet(portletNo) {
    return repository.delete(`${URI}/my-portlets/${portletNo}`)
  },
  changeMyPortletPosition(portletNos: string[]) {
    return repository.post(`${URI}/change-portlet-position`, { portletNos })
  },
}

type Dashboard = {
  master: boolean
  superuser: boolean
  myPortlets?: MyPortlet[]
  myHomeImages?: { image: AttachedImage; referenceId: string }[]
}
